import React from "react";
import { OptIn } from "@core-shop/components";
import { OptInModalView } from "./OptInModalView";

export const OptInModal: React.FC = () => {
  return <OptIn View={OptInModalView} />;
};
